<template>
  <div class="common-card quotation-list-wrapper">
    <modal-filter
      :filter_quotation_type_id.sync="filter_quotation_type_id"
      :filter_customer_id.sync="filter_customer_id"
      :filter_project_id.sync="filter_project_id"
      :filter_quotating.sync="filter_quotating"
      :quotationTypeOptions="quotationTypeOptions"
      :customerOptions="handleAdminCustomerOptions"
      :projectOptions="projectOptions"
      @refetch-data="refetchData"
    />
      <!-- :productOptions="productOptions"
      :filter_product_id.sync="filter_product_id"
      :filter_stamp_id.sync="filter_stamp_id" -->
    <b-card class="top mb-0">
      <div class="d-flex flex-wrap align-items-center justify-content-between">
        <div class="d-flex mb-1 mb-sm-0 align-items-center">
          <h4 class="font-weight-bolder ml-1 text-nowrap mb-0">
            <font-awesome-icon class="mr-50" icon="fa-solid fa-file-invoice" />
            報價單資料
          </h4>
          <div class="d-flex ml-3 align-items-center">
            <label>顯示</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>條目</label>
          </div>
        </div>
        <div class="d-flex mobile-w100 flex-wrap mt-1 mt-lg-0">
          <b-form-input
            v-model="searchQuery"
            class="search-form mb-1 mb-sm-0 mr-1"
            placeholder="搜尋報價單"
          />
          <b-button
            variant="primary"
            class="mr-sm-1 mobile-w100 mb-1 mb-sm-0"
            @click="$bvModal.show('modal-filter')"
            ><feather-icon
              class="mr-1"
              icon="filterIcon"
              size="18"
            ></feather-icon
            >篩選</b-button
          >
          <b-button class="mobile-w100" :to="{ name: 'quotation-create' }"  v-if="ability.can('create', 'quotations')">
            <feather-icon class="mr-1" icon="plusIcon" size="18"></feather-icon
            >新增報價單</b-button
          >
        </div>
      </div>
    </b-card>

    <b-card no-body class="card-statistics bottom">
      <b-card-body class="p-2">
        <b-table
          ref="refQuotationListTable"
          class="position-relative"
          :items="fetchQuotations"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="未找到匹配的記錄"
          :sort-desc.sync="isSortDirDesc"
        >
          <!-- Column: quotation_type_id -->
          <template #cell(quotation_type_id)="data">
            {{ getQuotationType(data.item.quotation_type_id) }}
          </template>

          <template #cell(id)="data">
            {{ data.item.quotation_number }}
          </template>

          <!-- Column: salary_items -->
          <template #cell(show_details)="row">
            <b-button
              v-if="row.item.cost_items"
              size="sm"
              @click="row.toggleDetails()"
              class="mr-2"
            >
              {{ row.detailsShowing ? "隱藏" : "顯示" }}
            </b-button>
          </template>

          <template #row-details="row">
            <div class="info-container" v-if="row.item.salary_records && row.item.salary_records.length">
              <b-row
                class="p-2 backgroundColor5 mb-1"
                v-for="(worker, index) in row.item.salary_records"
                :key="`cost${index}`"
              >
                <b-col cols="12" md="4">
                  <div class="row mb-50">
                    <b class="label">師傅：</b>
                    <span>{{ getWorkerName(worker.worker_id) }}</span>
                  </div>
                  <div class="row mb-50">
                    <b class="label">職位：</b>
                    <span>{{ worker.position }}</span>
                  </div>
                  <div class="row mb-50">
                    <b class="label">工資：</b>
                    <span
                      >{{ worker.working_days }}天 * ${{
                        Number(worker.day_salary).toFixed(2)
                      }}每日 = ${{ Number(worker.total_salary).toFixed(2) }}</span
                    >
                  </div>
                </b-col>
                <b-col cols="12" md="4">
                  <div class="row mb-50">
                    <b class="label">開工日期：</b>
                    <pre>{{ worker.working_date }}</pre>
                  </div>
                </b-col>
              </b-row>
            </div>
            <div class="info-container" v-if="row.item.cost_items && row.item.cost_items.length">
              <b-row
                class="p-2 backgroundColor3 mb-1"
                v-for="(cost, index) in row.item.cost_items"
                :key="`cost${index}`"
              >
                <b-col cols="12" md="4">
                  <div class="row mb-50">
                    <b class="label">商品分類：</b>
                    <span>{{ getProductCategoryName(cost.product_category_id) }}</span>
                  </div>

                  <div class="row mb-50">
                    <b class="label">商品：</b>
                    <span>{{ getProductName(cost.product_id) }}</span>
                  </div>

                  <div class="row mb-50">
                    <b class="label">金額：</b>
                    <span
                      >{{ parseFloat(Number(cost.quantity).toString()) + getProductUnit(cost.product_id) }} *
                      ${{ Number(cost.unit_price).toFixed(2) }} = ${{ Number(cost.amount).toFixed(2) }}</span
                    >
                  </div>
                </b-col>
                <b-col cols="12" md="4">
                  <div class="row mb-50">
                    <b class="label">增加空行數量：</b>
                    <pre>{{ cost.empty_rows }}</pre>
                  </div>
                  <!-- <div class="row mb-50">
                    <b class="label">尺寸：</b>
                    <pre>{{ cost.product && cost.product.size ? cost.product.size : '-' }}</pre>
                  </div> -->
                  <div class="row mb-50">
                    <b class="label">備註/尺寸：</b>
                    <span>{{ cost.item_description }}</span>
                  </div>
                </b-col>
              </b-row>
            </div>
          </template>

          <!-- Column: stamp -->
          <template #cell(stamp)="data">
            <feather-icon
              v-if="data.item.stamp_id"
              icon="CheckIcon"
              size="18"
              class="mr-50 text-success"
            />
          </template>

          <template #cell(created_at)="data">
            {{ getDateTime(data.item.created_at) }}
          </template>

          <template #cell(actions)="data">
            <b-dropdown
              :class="`action-trigger-btn ${
                quotationsList.length <= 3 ? 'hor' : 'ver'
              }`"
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="EyeIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>

          
              <b-dropdown-item
                v-if="ability.can('print', 'quotations')"
                :to="{ name: 'quotation-preview', params: { id: data.item.id } }"
              >
                <feather-icon icon="FileTextIcon" />
                <span class="align-middle ml-50">列印報價單</span>
              </b-dropdown-item>

              <b-dropdown-item
                v-if="ability.can('update', 'quotations')"
                :to="{
                  name: 'quotation-edit',
                  params: { id: data.item.id },
                }"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">修改資料</span>
              </b-dropdown-item>

              <b-dropdown-item
                v-if="ability.can('delete', 'quotations')"
                @click="removeItem(data.item.id)"
              >
                <feather-icon icon="Trash2Icon" />
                <span class="align-middle ml-50">刪除記錄</span>
              </b-dropdown-item>

              <b-dropdown-item 
                v-if="ability.can('create', 'invoices')"
                :to="{
                  name: 'invoice-create',
                  query: { quotation_id: data.item.id },
                }">
                <feather-icon icon="BookIcon" />
                <span class="align-middle ml-50">生成發票</span>
              </b-dropdown-item>

              <b-dropdown-item
                v-if="ability.can('create', 'quotations')"
                :to="{
                  name: 'quotation-copy',
                  params: { id: data.item.id },
                }"
              >
                <feather-icon icon="CopyIcon" />
                <span class="align-middle ml-50">複製報價單</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >在{{ dataMeta.of }}個記錄中，正在顯示 {{ dataMeta.from }} 至
                {{ dataMeta.to }}個記錄</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRow"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>
    
<script>
import {
  BCard,
  BCardBody,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import useQuotationsList from "./useQuotationsList";
import quotationStoreModule from "../quotationStoreModule";
import ModalFilter from "../modal/ModalFilter.vue";
import { getDateTime } from '@/libs/helper'

export default {
  components: {
    ModalFilter,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
  },
  
  data() {
    return {
      invoiceData:null
    };
  },
  computed: {
    handleAdminCustomerOptions() {
      if (this.ability.can("admin", "quotations")) {
        return this.customerOptions;
      } else {
        if(!this.quotationsList || !this.quotationsList.length){
          return [];
        } 
         const referencedCustomerIds = this.quotationsList
          .map((item) => item.customer_id)
          .filter((id) => id !== null && id !== undefined);

        // 去重
        const uniqueCustomerIds = [...new Set(referencedCustomerIds)];

        // 從 invoiceOptions 中篩選出被引用的發票
        return this.customerOptions.filter((customer) =>
          uniqueCustomerIds.includes(customer.id)
        );
      }
    }
  },  
  methods: {
    getQuotationType(typeId) {
      if (!typeId || !this.quotationTypeOptions || !this.quotationTypeOptions.length) {
        return '';
      }
      const type = this.quotationTypeOptions.find(function(ele) {
        return ele.id === typeId;
      });
      return type ? type.name : '';
    },

    getWorkerName(workerId) {
      if (!workerId || !this.workerOptions || !this.workerOptions.length) {
        return '';
      }
      const worker = this.workerOptions.find(function(ele) {
        return ele.id === workerId;
      });
      return worker ? worker.name_cn : '';
    },

    getProductCategoryName(categoryId) {
      if (!categoryId || !this.productCategoriesOptions || !this.productCategoriesOptions.length) {
        return '';
      }
      const category = this.productCategoriesOptions.find(function(ele) {
        return ele.id === categoryId;
      });
      return category ? category.name : '';
    },

    getProductName(productId) {
      if (!productId || !this.productOptions || !this.productOptions.length) {
        return '';
      }
      const product = this.productOptions.find(function(ele) {
        return ele.id === productId;
      });
      return product ? product.product_name : '';
    },

    getProductUnit(productId) {
      if (!productId || !this.productOptions || !this.productOptions.length) {
        return '件';
      }
      const product = this.productOptions.find(function(ele) {
        return ele.id === productId;
      });
      return product ? (product.unit || '件') : '件';
    },

    getProject(id) {
      if (!id || !this.projectOptions || !this.projectOptions.length) {
        return null;
      }
      return this.projectOptions.find(function(ele) {
        return ele.id === id;
      });
    },
    removeItem(id) {
      // check number of record
      this.$swal({
        title: "你確定嗎?",
        text: "您的決定是最終決定，您將無法取回這記錄。",
        showCancelButton: true,
        confirmButtonText: "刪除",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("quotation/deleteQuotation", { id })
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.refetchData();
            })
            .catch((error) => {
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    // generateInvoice(item) {
    //   this.invoiceData = item;
    //   this.invoiceData.quotation_id = item.id
    //   this.invoiceData.id = 0
    //   this.invoiceData.invoice_type_id = this.invoiceData.quotation_type_id
    //   this.invoiceData.invoice_date = getDateTime(new Date(), 1)
    //   delete this.invoiceData.quotation_type
    //   delete this.invoiceData.quotation_type_id
    //   delete this.invoiceData.quotation_remark
    //   delete this.invoiceData.quotation_date
    //   delete this.invoiceData.quotation_number
      
    // }
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = "quotation";

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, quotationStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    const getProductCategory = (id) => {
      if (id) {
        const obj =
          productCategoriesOptions.value &&
          productCategoriesOptions.value.length > 0 &&
          productCategoriesOptions.value.find((ele) => ele.id == id);
        return { ...obj };
      } else {
        return "- -";
      }
    };
    const getProduct = (id) => {
      if(id){
        const obj = productOptions.value && productOptions.value.length > 0 && productOptions.value.filter(ele => ele.id == id)[0]
        return {...{unit:'件'},...obj}
      }else{
        return {unit:'件'}
      }
    };
    const invoiceData = ref(null)

    const {
      fetchQuotations,
      tableColumns,
      perPage,
      currentPage,
      totalRow,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      quotationsList,
      refQuotationListTable,
      refetchData,
      ability,
      refetchOption,
      filter_quotation_type_id,
      filter_customer_id,
      filter_product_id,
      filter_stamp_id,
      filter_project_id,
      filter_quotating,
      quotationTypeOptions,
      customerOptions,
      projectOptions,
      productOptions,
      workerOptions,
      productCategoriesOptions
    } = useQuotationsList();

    return {
      fetchQuotations,
      tableColumns,
      perPage,
      currentPage,
      totalRow,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      quotationsList,
      refQuotationListTable,
      refetchData,
      ability,
      refetchOption,
      filter_quotation_type_id,
      filter_customer_id,
      filter_product_id,
      filter_stamp_id,
      filter_project_id,
      filter_quotating,
      quotationTypeOptions,
      customerOptions,
      projectOptions,
      productOptions,
      workerOptions,
      productCategoriesOptions,
      getProduct,
      invoiceData,
      getProductCategory
    };
  },
};
</script>
    
<style lang="scss" scoped>
.per-page-selector {
  width: 100px;
}

// @media screen and (max-width: 768px) {

// }
// @media screen and (max-width: 575px) {

// }
</style>
    
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@/assets/scss/variables/_variables.scss";
@media (min-width: 540px) {
  .quotation-list-wrapper {
    .sticky-column {
      &:nth-child(1) {
        width: 140px!important;
        min-width: 140px!important;
        max-width: 140px!important;
      }
      &:nth-child(2) {
        left: 140px;
      }
      &:nth-child(3) {
        left: 260px;
      }
    }
  }
}
</style>
    